<template>
    <b-row class="reports-toolbar">
        <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <b-input-group id="daterange_transaction">
                <b-input-group slot="append">
                    <i class="icon-calendar" style="cursor: pointer" data-toggle @click="openRangePicker"></i>
                    <i class="icon-clear" style="cursor: pointer" data-toggle @click="clearRangePicker"></i>
                </b-input-group>
                <datepicker
                    ref="rangePicker"
                    :config="dateRangeConfig">
                </datepicker>
            </b-input-group>
        </b-col>
        <b-col lg="9" class="text-left text-lg-right">
            <b-form-file
                hidden
                accept=".tsv"
                ref="importCsv"
                v-model="file.csvfile">
            </b-form-file>
            <b-button
                variant="primary btn-table-import"
                @click="browseCSV">
                <template v-if="uploading">
                    Uploading...
                </template>
                <template v-else>
                    Upload TSV
                </template>
            </b-button>
            <b-input-group class="d-inline-flex">
                <b-button variant="export-opts ml-3 text-left" disabled>
                    Export
                </b-button>
                <template slot="append">
                    <b-dropdown>
                        <b-dropdown-item
                            @click="exportAssetMaster('excel')">
                            Excel
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="exportAssetMaster('pdf')">
                            PDF
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-input-group>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";
import notification from "../../../services/notification";
import Datepicker from "vue-bulma-datepicker";

export default {
    name: "TransactionUploadToolbar",
    components: {
        Datepicker
    },
    data() {
        return {
            statusFilter: "all",
            statusFilters: [
                {
                    value: "all",
                    text: "Show All"
                }
            ],
            searchString: "",
            file: {
                csvfile: null,
                error_type:
                    "You have used an invalid file format. Please check the file format and try again. <br/> Note: Only TSV file is acceptable in the system."
            },
            advanceFilter: null,
            advanceFilters: [{ value: null, text: "All" }],
            filterLabels: [],
            rangePicker: null
        };
    },
    computed: {
        ...mapState("reportsTransactionUpload", [
            "loading",
            "uploading",
            "import",
            "importfile",
            "importBase",
            "param",
            "filters",
            "confirm"
        ]),
        dateRangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    defaultDate: ["today", "today"],
                    onChange: async function(selectedDates) {
                        let range = {
                            start_date: null,
                            end_date: null
                        };
                        if (selectedDates.length > 0) {
                            range.start_date = _this.$moment(selectedDates[0]).format("YYYY-MM-DD");
                            range.end_date = _this.$moment(selectedDates[1]).format("YYYY-MM-DD");
                        }

                        await _this.$store.commit("reportsTransactionUpload/setFilterDate", range);

                        _this.$store.dispatch("reportsTransactionUpload/getList", {
                            page: _this.param.page,
                            range: _this.param.range
                        });
                    },
                    onReady: function(selectedDates, dateStr, instance) {
                        _this.rangePicker = instance;
                    }
                };
            }
        }
    },
    methods: {
        confirmUpload: function(file) {
            this.$store.commit("reportsTransactionUpload/setConfirmModal", true);
            this.$store.commit("reportsTransactionUpload/setImportTransactionUpload", file);
        },

        browseCSV: function() {
            this.$refs.importCsv.$el.children[0].click();
        },

        exportAssetMaster: async function(format) {
            switch (format) {
                case "excel":
                    await this.$store.dispatch("reportsTransactionUpload/exportXls", this.param.range);
                    break;
                case "pdf":
                    await this.$store.dispatch("reportsTransactionUpload/exportPdf", this.param.range);
                    break;
            }
        },

        transformFilterText: async function(text) {
            let labels = [];
            for (var i = 0; text.length > i; i++) {
                let label = text[i].charAt(0).toUpperCase() + text[i].slice(1);
                labels.push(label);
            }
            await this.filterLabels.push(labels.join(" "));
        },

        openRangePicker() {
            this.rangePicker.toggle();
        },
        clearRangePicker() {
            this.rangePicker.clear();
        }
    },
    watch: {
        "file.csvfile": async function(file) {
            if (file !== null) {
                if (file !== null) {
                    this.confirmUpload(file);
                }
            }
        },

        import: function() {
            if (this.import) {
                let _this = this;
                this.$store.dispatch("reportsTransactionUpload/importTransactionUpload");
                this.$store.dispatch("reportsTransactionUpload/getList", _this.param);
                this.$refs.importCsv.reset();
            }
        },
        
        confirm: function(value) {
            if (value === false) {
                this.$refs.importCsv.reset();
            }
        }
    }
}
</script>
